var objTicketDatePicker = {
    // <summary>
    // This object holds all functions for date picker related functionality in ticket.js
    // </summary>

    _setDatePickerState: function (me, obj, val, bEdit) {
        /// <summary>
        ///  This function handles the date picker states for date completion, execution and validation incl. the click handler for removing existing dates. 
        /// </summary>
        var dt;
        try {
            if (me.error) { return false; }
            obj.clear.hide();
            if (!bEdit) {
              obj.txtDate.val(val.length === 0 ? "-" : val);
            } else {
                //if we got a date
                if (val.length > 0) {
                    obj.clear.show();
                    //and we haven't initialized it
                    if (!obj.divDate.hasClass("vc-date")) {
                        dt = $.datepicker.formatDate('dd.mm.yy', $.datepicker.parseDate('dd.mm.yy', val));
                        obj.divDate.val(dt);
                        objTicketDatePicker._initDatePicker(me,obj.divDate, dt);
                    }
                } else {
                    if (obj.divDate.html().length === 0) {
                        // we check if accounting mode is active and permanent ticket is opened
                        // if so, we disable the date picker, because a permanent ticket in accounting mode cannot have a finish date
                        var isAccounting = me.myHtml.rowAccounting.dateAccounting === obj;
                        var isPermanentTicket = me.isPermanentTicket;

                        if (isAccounting && isPermanentTicket) {
                            // if permanent ticket in accounting mode, disable date picker
                            obj.divDate.html("<div class='add-date-picker permanent-no-accounting'>-</div>");
                            var btnPerm = obj.divDate.find(".add-date-picker");

                            // deactivate button
                            btnPerm.button();
                            btnPerm.button("disable");

                            obj.clear.hide();
                            return true;
                        }

                        obj.divDate.html("<div class='add-date-picker'>" + me.specific.resources.setDate + "</div>");
                        var btn = obj.divDate.find(".add-date-picker");

                        btn.on("click", function () {

                            var doInit = function () {
                                var dt = $.datepicker.formatDate('dd.mm.yy', $.datepicker.parseDate('dd.mm.yy', window.getCurrentTimestamp()) );
                                objTicketDatePicker._initDatePicker(me, obj.divDate, dt);
                                if (bEdit) { obj.clear.show(); }
                            };

                            // if accounting mode is active, we need to check for unbilled activities first                           
                            if (isAccounting && me.specific.ticketId && typeof me.updateData === "function") {

                                var stateVal = -1;

                                // get current state from ddlStates
                                if (me.ddlStates && typeof me.ddlStates.getValue === "function") {
                                    var v = me.ddlStates.getValue();
                                    if ($.isArray(v) && v.length > 0) {
                                        stateVal = parseInt(v[0], 10) || -1;
                                    } else {
                                        stateVal = parseInt(v, 10) || -1;
                                    }
                                }

                                var doneId = typeof me.specific.STATE_DONE_TYPEID !== "undefined" ? me.specific.STATE_DONE_TYPEID : -1;
                                var permanentId = typeof me.specific.STATE_PERMANENT_TYPEID !== "undefined" ? me.specific.STATE_PERMANENT_TYPEID : -1;

                                var isPermanent = (permanentId !== -1 && stateVal === permanentId);
                                var isDone = (doneId !== -1 && stateVal === doneId);

                                // if permanent ticket, we allow setting the date without checking for done status
                                // otherwise, we need to be in done status to set the finish date
                                if (!isPermanent && doneId !== -1 && !isDone) {
                                    me.openInfoDialog(me.specific.resources.alertAccountingStateMustBeDone, { at: 'center center-20%', of: window }); return true;
                                }

                                var orderTypeVal = -1;

                                // get current order type from ddlOrderType
                                if (me.ddlOrderType && typeof me.ddlOrderType.getValue === "function") {
                                    var ov = me.ddlOrderType.getValue();

                                    if ($.isArray(ov) && ov.length > 0) {
                                        orderTypeVal = parseInt(ov[0], 10) || -1;
                                    } else {
                                        orderTypeVal = parseInt(ov, 10) || -1;
                                    }
                                }

                                // "no entry" is not allowed; user must select another order type before finishing the accounting
                                if (orderTypeVal === -1) {
                                    me.openInfoDialog(me.specific.resources.alertOrderTypeMustBeSelected, { at: 'center center-20%', of: window });
                                    return true;
                                }





                                me.updateData({ typeid: 3, TicketID: me.specific.ticketId }, function (res) {
                                    if (res && res.Success === true && res.HasUnbilledActivities === false) {
                                        // everything is billed, we can proceed
                                        doInit();
                                    } else if (res && res.HasUnbilledActivities === true) {
                                        // unbilled activities exist, show warning and block       
                                        me.openInfoDialog(me.specific.resources.alertNotBilledActivitiesExist, { at: 'center center-20%', of: window }); return true;
                                    } else {
                                        doInit();
                                    }
                                });

                            } else {
                                doInit();
                            }

                        }).button();

                        obj.clear.hide();

                    }
                }
            }
            return true;
        } catch (ex) { me._writeErr(ex); return false }

    },

    _initDatePicker: function (me,obj, dt) {
        /// <summary>
        ///  This function inits the vc-date instance
        /// </summary>
        try {
            if (me.error) {return false;}
            obj.html("");
            obj.vcDate({ defaultDate: dt, mode: "Single", align: "center", interval: 1, langID: me.settings.userLangid, callback: function () { me._setDirty(obj) } });
            return true;
        } catch (ex) { me._writeErr(ex); return false }

    },

    _removeDatePicker: function (me,obj) {
        /// <summary>
        ///  This function removes the vc-date instance
        /// </summary>
        try {
            if (me.error) {return false;}
            var id = obj.data("date");
            me.fnd("#" + id).vcDate("destroy");
            me.fnd("#" + id).removeClass("vc-date").html("");
            me.fnd("#" + id).parents(".type-date").removeClass("removed-date-picker").addClass("removed-date-picker");

            me._setDirty(me.visual.find("#" + id));
            obj.hide();
            return true;
        } catch (ex) { me._writeErr(ex); return false }

    },
};